import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { depositorConfig } from './depositorConfig';
import { createDepositorValidationSchema } from './depositorValidation';

/**
 * Initialize the Depositor module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  depositorConfig,
  createDepositorValidationSchema
);

/**
 * Create the DepositorPage using the generic module page factory
 */
const DepositorPage = createModulePage(
  initializedConfig,
  {
    displayName: 'DepositorPage',
    description: 'Depositor Management System - Depositor information and contact management'
  }
);

export default DepositorPage;

